module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "text": "",
      "to": '/stammbaum/daten'
    }
  }, [_vm._v("Daten")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-autocomplete', {
    attrs: {
      "single-line": "",
      "solo": "",
      "flat": "",
      "items": _vm.bbrbbr,
      "label": "Bundesbruder"
    },
    model: {
      value: (_vm.bundesbruder),
      callback: function($$v) {
        _vm.bundesbruder = $$v
      },
      expression: "bundesbruder"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "hidden-xs-only",
    attrs: {
      "single-line": "",
      "solo": "",
      "flat": "",
      "items": _vm.leibfamilienGrunder,
      "label": "Leibfamilien"
    },
    model: {
      value: (_vm.bundesbruder),
      callback: function($$v) {
        _vm.bundesbruder = $$v
      },
      expression: "bundesbruder"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.collapse = !_vm.collapse
            }
          }
        }, on), [_c('v-icon', [_vm._v(_vm._s(_vm.collapse ? 'unfold_more' : 'unfold_less'))])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Kollapse")])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "offset-md": "3"
    }
  })], 1), _vm._v(" "), _c('v-sheet', {
    staticClass: "align-center",
    attrs: {
      "id": "container",
      "height": _vm.screenHeight - 169
    }
  }, [(_vm.currentbundesbruder) ? _c('stammbaum', {
    attrs: {
      "dense": true,
      "collapse": _vm.collapse,
      "bbr": _vm.currentbundesbruder,
      "currentBbr": _vm.currentbundesbruder.id
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-472e71fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stammbaum/Uebersicht.vue
// module id = 770
// module chunks = 15